import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { PageInfo, QueryPagedUsersGQL, QueryPagedUsersQuery, UserOrderByInput } from '@generated/sammathnaur.graphql'
import { Subject, firstValueFrom } from 'rxjs'
import { BasePaginationService } from '../../components/pagination/pagination.type'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class UsersService implements BasePaginationService {

  public search$: Subject<void> = new Subject()

  public readonly filterForm = new FormGroup({
    nameContains: new FormControl(''),
    emailContains: new FormControl(''),
    nameOrEmailContains: new FormControl(''),
    roleIn: new FormControl(),
    typeIn: new FormControl(),
    groupId: new FormControl(''),
    locationId: new FormControl(''),
    archived: new FormControl(false as 'all' | false | true),
    mfaEnabled: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<UserOrderByInput>(UserOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)
  public totalCount = signal<number>(0)
  public pageInfo = signal<PageInfo | undefined>(undefined)
  public isLoading = signal<boolean>(false)

  private readonly usersPageGQL = inject(QueryPagedUsersGQL)

  public async searchPage(): Promise<Apollo.QueryResult<QueryPagedUsersQuery>> {
    const { nameContains, archived } = this.filterForm.value

    const observable$ = this.usersPageGQL.fetch({
      variables: {
        where: {
          name_contains: nameContains,
          archived: archived === 'all' ? undefined : archived,
        },
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }
}
